 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","views-manage-subadmin-subadmin-module":"views-manage-subadmin-subadmin-module","views-role-permission-role-permission-module":"views-role-permission-role-permission-module","default~views-appointment-management-appointment-management-module~views-billing-management-billing-~4b04a1fb":"default~views-appointment-management-appointment-management-module~views-billing-management-billing-~4b04a1fb","views-dashboard-dashboard-module":"views-dashboard-dashboard-module","views-purchase-orders-purchase-order-module":"views-purchase-orders-purchase-order-module","default~views-appointment-management-appointment-management-module~views-billing-management-billing-~60a3aa10":"default~views-appointment-management-appointment-management-module~views-billing-management-billing-~60a3aa10","default~views-appointment-management-appointment-management-module~views-billing-management-billing-~65b1cb9a":"default~views-appointment-management-appointment-management-module~views-billing-management-billing-~65b1cb9a","default~views-doctor-management-doctor-management-module~views-hospital-management-hospital-manageme~f02e24ad":"default~views-doctor-management-doctor-management-module~views-hospital-management-hospital-manageme~f02e24ad","default~views-base-base-module~views-doctor-management-doctor-management-module~views-hospital-manag~06339e04":"default~views-base-base-module~views-doctor-management-doctor-management-module~views-hospital-manag~06339e04","views-hospital-management-hospital-management-module":"views-hospital-management-hospital-management-module","views-supplier-management-supplier-management-module":"views-supplier-management-supplier-management-module","views-city-management-city-management-module":"views-city-management-city-management-module","views-specialization-management-specialization-management-module":"views-specialization-management-specialization-management-module","views-symptoms-management-symptoms-management-module":"views-symptoms-management-symptoms-management-module","default~views-appointment-management-appointment-management-module~views-billing-management-billing-~d92576d6":"default~views-appointment-management-appointment-management-module~views-billing-management-billing-~d92576d6","default~views-billing-management-billing-module~views-order-management-order-management-module":"default~views-billing-management-billing-module~views-order-management-order-management-module","views-billing-management-billing-module":"views-billing-management-billing-module","views-appointment-management-appointment-management-module":"views-appointment-management-appointment-management-module","views-inquiry-management-inquiry-management-component-module":"views-inquiry-management-inquiry-management-component-module","views-labs-management-labs-management-module":"views-labs-management-labs-management-module","views-notification-management-notification-management-module":"views-notification-management-notification-management-module","default~views-diagnostic-management-diagnostic-management-module~views-doctor-management-doctor-mana~aa0a1a07":"default~views-diagnostic-management-diagnostic-management-module~views-doctor-management-doctor-mana~aa0a1a07","default~views-diagnostic-management-diagnostic-management-module~views-doctor-management-doctor-mana~d8d6bb28":"default~views-diagnostic-management-diagnostic-management-module~views-doctor-management-doctor-mana~d8d6bb28","default~views-doctor-management-doctor-management-module~views-doctors-consultations-doctors-consult~56a52c57":"default~views-doctor-management-doctor-management-module~views-doctors-consultations-doctors-consult~56a52c57","default~views-base-base-module~views-doctor-management-doctor-management-module~views-patient-manage~f1f614ea":"default~views-base-base-module~views-doctor-management-doctor-management-module~views-patient-manage~f1f614ea","default~views-doctor-management-doctor-management-module~views-patient-management-patient-management~7020677e":"default~views-doctor-management-doctor-management-module~views-patient-management-patient-management~7020677e","default~views-doctor-management-doctor-management-module~views-patient-management-patient-management~276fc254":"default~views-doctor-management-doctor-management-module~views-patient-management-patient-management~276fc254","default~views-base-base-module~views-patient-management-patient-management-module":"default~views-base-base-module~views-patient-management-patient-management-module","views-patient-management-patient-management-module":"views-patient-management-patient-management-module","default~views-cms-cms-module~views-email-template-email-module":"default~views-cms-cms-module~views-email-template-email-module","views-cms-cms-module":"views-cms-cms-module","views-email-template-email-module":"views-email-template-email-module","default~views-diagnostic-management-diagnostic-management-module~views-manage-category-category-modu~0fb7ee50":"default~views-diagnostic-management-diagnostic-management-module~views-manage-category-category-modu~0fb7ee50","views-manage-category-category-module":"views-manage-category-category-module","views-master-logs-master-logs-module":"views-master-logs-master-logs-module","views-ipd-management-ipd-management-module":"views-ipd-management-ipd-management-module","views-diagnostic-management-diagnostic-management-module":"views-diagnostic-management-diagnostic-management-module","default~views-base-base-module~views-referral-management-referral-management-module~views-review-rev~39017a36":"default~views-base-base-module~views-referral-management-referral-management-module~views-review-rev~39017a36","views-referral-management-referral-management-module":"views-referral-management-referral-management-module","views-reward-management-reward-management-module":"views-reward-management-reward-management-module","views-doctors-consultations-doctors-consultations-module":"views-doctors-consultations-doctors-consultations-module","views-base-base-module":"views-base-base-module","default~views-doctor-management-doctor-management-module~views-pharmacy-management-pharmacy-manageme~d743658c":"default~views-doctor-management-doctor-management-module~views-pharmacy-management-pharmacy-manageme~d743658c","views-review-review-module":"views-review-review-module","views-user-report-user-report-module":"views-user-report-user-report-module","views-order-management-order-management-module":"views-order-management-order-management-module","views-doctor-management-doctor-management-module":"views-doctor-management-doctor-management-module","views-pharmacy-management-pharmacy-management-module":"views-pharmacy-management-pharmacy-management-module","default~views-theme-theme-module~views-widgets-widgets-module":"default~views-theme-theme-module~views-widgets-widgets-module","views-widgets-widgets-module":"views-widgets-widgets-module","views-theme-theme-module":"views-theme-theme-module","views-buttons-buttons-module":"views-buttons-buttons-module","views-chartjs-chartjs-module":"views-chartjs-chartjs-module","views-faq-faq-module":"views-faq-faq-module","views-icons-icons-module":"views-icons-icons-module","views-manage-contact-manage-contact-module":"views-manage-contact-manage-contact-module","views-notifications-notifications-module":"views-notifications-notifications-module","views-profile-profile-module":"views-profile-profile-module","views-settings-settings-module":"views-settings-settings-module","views-video-upload-video-upload-module":"views-video-upload-video-upload-module","views-whatsapp-management-whatsapp-management-module":"views-whatsapp-management-whatsapp-management-module","canvg":"canvg","dompurify":"dompurify","pdfjsWorker":"pdfjsWorker"}[chunkId]||chunkId) + "-es5.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
